import Vue from 'vue'
import Router from 'vue-router'
//页面路由导入
import index from '@/components/index'
import system from '@/components/system'
import dataManage from '@/data/dataManage'
import importNais from '@/data/importNais'
import newCase from '@/data/newCase'
import exportChoose from '@/exportData/exportChoose'
import exportSearch from '@/exportData/exportSearch'
import exportEXCEL from '@/exportData/exportEXCEL'
import importDXF from '@/importData/importDXF'
import importPC from '@/importData/importPC'
import login from '@/login/login'
import newUser from '@/user/newUser'
import personIfo from '@/user/personIfo'
import userManage from '@/user/userManage'
import categoryCatalog from '@/statistics/categoryCatalog'
import numberStatistics from '@/statistics/numberStatistics'

Vue.use(Router);
/**
 * 声明路由
 * @type {VueRouter}
 */
 const router = new Router({
  mode:'history',
  routes: [
    //登陆路由
    {
      path: '/',
      name: 'login',
      component: login
    },
    //系统父路由
    {
      path: '/system',
      name: 'system',
      component: system,
      children:[
        //功能子路由
        {path:'index',component:index,name:'系统首页'},
        {path:'dataManage',component:dataManage,name:'数据管理'},
        {path:'newCase',component:newCase,name:'新建案例数据'},
        {path:'importNais',component:importNais,name:'导入NAIS数据'},
        {path:'importDXF',component:importDXF,name:'导入DXF数据'},
        {path:'importPC',component:importPC,name:'导入PC数据'},
        {path:'exportChoose',component:exportChoose,name:'勾选导出'},
        {path:'exportSearch',component:exportSearch,name:'检索导出'},
        {path:'exportEXCEL',component:exportEXCEL,name:'案例信息导出'},
        {path:'newUser',component:newUser,name:'新建用户'},
        {path:'userManage',component:userManage,name:'用户管理'},
        {path:'categoryCatalog',component:categoryCatalog,name:'场景分类目录'},
        {path:'numberStatistics',component:numberStatistics,name:'系统数据统计'}
      ]
    }
  ]
});
/*
* 路由权限拦截函数
* */
router.beforeEach((to,from,next)=>{
  if (to.path !== '/' && !localStorage.token) {
    return next('/')
  }
  next()
});
/**
 * 暴露路由
 */
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js